import { z } from 'zod'

/**
 * A PixelSign record id. Branded, so a plain string (a route param, a database
 * column, a caller's input) can't pass for one without being parsed.
 */
export const uuidSchema = z.string().uuid().brand<'Uuid'>()

export type Uuid = z.infer<typeof uuidSchema>

/**
 * Brands an id read from a source that only holds ids (a database column),
 * throwing if it isn't one. A nullable column stays nullable; an id that may be
 * missing has to be handled before it gets here. Use it only where the type
 * asks for a `Uuid`: not every id column is one (an MCP client's id can be a
 * URL), and the compiler can't tell when a parse wasn't needed.
 */
export function parseUuid(value: string): Uuid
export function parseUuid(value: string | null): Uuid | null
export function parseUuid(value: string | null): Uuid | null {
  return value === null ? null : uuidSchema.parse(value)
}

export const uuidParamSchema = uuidSchema

/** Signer magic-link token (base64url, 32 bytes → 43 chars). */
export const signingTokenParamSchema = z
  .string()
  .min(16)
  .max(128)
  .regex(/^[A-Za-z0-9_-]+$/, 'Invalid signing token')

/** Invitation and password-reset link token (base64url, 32 bytes → 43 chars). */
export const linkTokenParamSchema = z
  .string()
  .min(16)
  .max(128)
  .regex(/^[A-Za-z0-9_-]+$/, 'Invalid link')
